module.exports = __webpack_public_path__ + "img/globus.126be7d7.svg";